import React, {
  ReactElement,
  useMemo,
  useState,
  useCallback,
  useEffect
} from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import style from './index.module.css';
import ImproveContent from '../../components/improve-content/improve-content';
import Rate from '../../../../components/rate/rate';
import Toast from '../../../../components/toast';
import { submitAfterSalesQuestionnaire } from '../../../../api/filling-pile';
import {
  closeWindow,
  getPlatform,
  go2LoginIfNot,
  webviewOpen
} from '../../../../utils/common';
import OrdinaryModel from '../../../../components/ordinary-model';
import Confirm from '../../../../components/confirm';
import FullLoading from '../../../../components/full-loading';

enum ServiceWeakness {
  lowSpeed,
  arbitraryCharge,
  badAttitude,
  poorRepairQuality,
  other
}

const App = (): ReactElement => {
  const router = useHistory();
  const loc = useLocation();
  const orderNo: any = new URLSearchParams(loc.search).get('orderNo');
  // 留言
  const [comment, setComment] = useState('');
  // 改进选项
  const improveArray = [
    { name: '上门维修不及时', value: ServiceWeakness.lowSpeed },
    { name: '不按收费标准收费', value: ServiceWeakness.arbitraryCharge },
    { name: '维修师傅态度差', value: ServiceWeakness.badAttitude },
    { name: '维修质量差', value: ServiceWeakness.poorRepairQuality },
    { name: '其他', value: ServiceWeakness.other }
  ];
  // 选中项
  const [selected, setSelected] = useState<number[]>([]);

  const [userInfo, setUserInfo] = useState({ uid: '', name: '' });

  const [rateVal, setRateVal] = useState(0);

  const [isSubmiting, setIsSubmiting] = useState(false);

  useEffect(() => {
    document.title = '售后问卷填写';
  }, []);

  const handleSelect = useCallback(
    (val: number[]) => {
      setSelected(val);
    },
    [selected]
  );

  const btnCanSubmit = useMemo(() => {
    if (!rateVal) return false;
    if (rateVal <= 4 && selected.length === 0) return false;
    if (selected && selected.includes(ServiceWeakness.other) && !comment) return false;
    return true;
  }, [rateVal, selected, comment]);

  const improveVisible = useMemo(() => {
    if (rateVal <= 4 && rateVal !== 0) return true;
    return false;
  }, [rateVal]);

  const handleChange = e => {
    const val = e.target.value;
    setComment(val);
  };

  const handleRate = val => {
    if (val > 3) {
      setSelected([]);
    }
    setRateVal(val);
  };

  const submit = () => {
    if (!btnCanSubmit) {
      Toast.show({
        text: '请完成表单',
        duration:2000
      });
      return;
    }
    setIsSubmiting(true);
    if (isSubmiting) {
      // Toast.show({
      //   text: '提交中'
      // });
      FullLoading.show(
        {
          text: '提交中'
        }
      )
      return;
    }
    submitAfterSalesQuestionnaire({
      orderNo: orderNo,
      mark: rateVal,
      badAttitude: selected.indexOf(ServiceWeakness.badAttitude) !== -1 ? 1 : 0,
      arbitraryCharge:
        selected.indexOf(ServiceWeakness.arbitraryCharge) !== -1 ? 1 : 0,
      lowSpeed:
        selected.indexOf(ServiceWeakness.lowSpeed) !== -1 ? 1 : 0,
      other:
        selected.indexOf(ServiceWeakness.other) !== -1 ? 1 : 0,
      info: comment,
      uid: userInfo.uid ? userInfo.uid : '',
      name: userInfo.name ? userInfo.name : ''
    })
      .then(({ data }) => {
        setIsSubmiting(false);
        if (data) {
          Toast.show({
            text: '评价成功',duration:2000
          });
          FullLoading.hide()
          router.goBack();
        }
        console.log('提交成功',data);
      })
      .catch(e => {
        console.log('提交表单失败', e);
        Toast.show({
          text: e.message || '提交失败',
          duration: 2000
        });
        FullLoading.hide()
        setIsSubmiting(false);
      });
  };

  useEffect(() => {
    go2LoginIfNot()
      .then(loginData => {
        if (!loginData) {
          Confirm.open('请先登录', {
            type: 2,
            confirmText: '确定',
            header: '',
            confirmCbk: (destroy): void => {
              destroy();
              // 关闭h5
              closeWindow();
            }
          });
        } else {
          // 已登录
          const phoneModel = getPlatform();
          let name: string = loginData.username;
          if (phoneModel === 'android') {
            name = loginData.nickname;
          }
          setUserInfo({ uid: loginData.uid, name: name });
        }
      })
      .catch(e => {
        console.log('页面出错', e.message);
        closeWindow();
      });
  }, []);

  return (
    <div className={style.wrap}>
      <div className={style.content}>
        <p className={style.title}>你对本次售后服务的满意度</p>
        <Rate value={rateVal} onChange={handleRate}></Rate>
        {improveVisible && (
          <>
            <ImproveContent
              content={improveArray}
              selected={selected}
              handleSelect={handleSelect}
            ></ImproveContent>
          </>
        )}
        <p className={`${style.commentTitle} ${selected && selected.includes(ServiceWeakness.other) && style.required}`}>
          请问你在售后维修服务时遇到什么问题？
        </p>
        <div className={style.inputWrap}>
          <textarea
            className={style.input}
            placeholder="请输入"
            onChange={handleChange}
            value={comment}
          ></textarea>
        </div>
      </div>

      <div className={style.bottom}>
        <button
          className={`${!btnCanSubmit ? '' : style.btn} ${style.disabledBtn}`}
          onClick={submit}
        >
          提交评价
        </button>
      </div>

    </div>
  );
};

export default App;
